var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "LinkMessageSlot" } }, [
    _c("div", { attrs: { id: "link-area" } }, [
      _c(
        "p",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "bottom" },
              expression: "{ followCursor: true, placement: 'bottom' }",
            },
          ],
          attrs: { content: _vm.message.description },
          on: { click: _vm.toLink },
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.message.description) + "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "time-area" } }, [
      _vm.isUserYou
        ? _c("p", { staticStyle: { "margin-right": "2px" } }, [
            _vm._v(_vm._s(_vm.$t("message.you"))),
          ])
        : _c("p", { staticStyle: { "margin-right": "2px" } }, [
            _vm._v(_vm._s(_vm.message.user.name)),
          ]),
      _vm._v(" "),
      _c("p", [_vm._v("-")]),
      _vm._v(" "),
      _c("span", { staticStyle: { "margin-left": "2px" } }, [
        _vm._v(_vm._s(_vm.time)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }